const components = {};
export const pushComponent = (name, component) => {
  components[name] = component;
};
export default components;